import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import { Link } from '../../../router';
import Icon from '../../../components/shared/Icons/Icon';
import Input from '../../forms/Input';
import AutoCompleteInput from '../../forms/AutoCompleteInput';
import messages from '../messages';
import styles from '../styles';
import { isValidInput, getMinimumCharactersLengthByCountryCode } from '../../../utils/validation';

const { searchPlaceholder } = messages;

class HeaderSerp extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      what: props.currentSearch,
    };

    // NOTE: We can't use arrow function in method we want to test/spyOn
    // Ref -> https://github.com/airbnb/enzyme/issues/697
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTyping = this.handleTyping.bind(this);
    this.fetchAutocompleteRequest = debounce(this.props.fetchAutocompleteRequest, 600);
  }

  componentWillReceiveProps(nextProps) {
    if (
      get(nextProps.searchParameters, 'whatAccented') !==
      get(this.props.searchParameters, 'whatAccented')
    ) {
      this.setState({
        what: get(nextProps.searchParameters, 'whatAccented'),
      });
    }
  }

  handleTyping(event) {
    const { hasAutoCompleteFieldsInSerpPageSearch } = this.props;
    const search = event.target.value;
    this.setState(
      {
        what: search,
      },
      () => {
        if (hasAutoCompleteFieldsInSerpPageSearch) {
          if (!isEmpty(this.state.what)) {
            this.fetchAutocompleteRequest({ what: this.state.what });
          }
        }
      }
    );
  }

  handleSubmit(event) {
    event.preventDefault();
    const { what } = this.state;
    const { countryCode, onSearchChanged, verticalName, searchParameters } = this.props;

    const minLength = getMinimumCharactersLengthByCountryCode(countryCode);
    if (isValidInput(what, minLength)) {
      document.activeElement.blur();
      onSearchChanged({ what, verticalName, searchParameters });
    }
  }

  render() {
    const {
      intl,
      searchParameters,
      verticalName,
      hasAutoCompleteFieldsInSerpPageSearch,
    } = this.props;
    let inputElement;

    if (hasAutoCompleteFieldsInSerpPageSearch) {
      inputElement = (
        <AutoCompleteInput
          items={this.props.autoComplete}
          onChange={event => {
            this.handleTyping(event);
          }}
          onSelect={val => this.setState({ what: val })}
          value={this.state.what}
          placeholder={intl.formatMessage(searchPlaceholder)}
          style={{ border: 0 }}
        />
      );
    } else {
      inputElement = (
        <Input
          type="search"
          value={this.state.what}
          placeholder={intl.formatMessage(searchPlaceholder)}
          onChange={this.handleTyping}
          name="what_d"
        />
      );
    }

    return (
      <header className={verticalName} data-test="header">
        <Link route="home">
          <a className="icon">
            <Icon type={'logo'} fill="#FFFFFF" width={32} />
          </a>
        </Link>
        <form action="/q" onSubmit={this.handleSubmit} method="get">
          <input type="hidden" name="page" value="1" />
          <input type="hidden" name="isUserSearch" value="1" />
          <input type="hidden" name="type" value={get(searchParameters, 'type_id') || ''} />
          {inputElement}
          <button type="button" onClick={this.handleSubmit} data-test="search-button__serp">
            <Icon type="search" fill="#FFFFFF" width={17} />
          </button>
        </form>
        <style jsx>{styles}</style>
      </header>
    );
  }
}

HeaderSerp.defaultProps = {
  currentSearch: '',
  autoComplete: [],
  fetchAutocompleteRequest: null,
  hasAutoCompleteFieldsInSerpPageSearch: false,
};

HeaderSerp.propTypes = {
  searchParameters: PropTypes.object.isRequired,
  autoComplete: PropTypes.array,
  fetchAutocompleteRequest: PropTypes.func,
  verticalName: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  currentSearch: PropTypes.string,
  intl: intlShape, // eslint-disable-line react/require-default-props
  hasAutoCompleteFieldsInSerpPageSearch: PropTypes.bool,
  onSearchChanged: PropTypes.func.isRequired,
};

export default HeaderSerp;



// WEBPACK FOOTER //
// ./app/common/Header/HeaderSerp/index.js